import axios from "axios";

import { errorHandler, successHandler } from "./rails";

const npiDocumentAxios = axios.create({
  baseURL: process.env.BASE_URL,
  headers: {
    "Content-Type": "application/json",
    credentials: "include",
  },
  withCredentials: true,

});

const npiErrorHandler = error => {
  if (404 === error?.response?.status) {
    // Silently handle npi docs 404's, otherwise use default handling
    return Promise.reject(error);
  }
  return errorHandler(error);
};

npiDocumentAxios.interceptors.response.use(successHandler, npiErrorHandler);

export default npiDocumentAxios;
